export const isMobileDevice = (): boolean => {
  if (typeof window === "undefined") return false;

  // Check user agent for mobile devices
  const userAgent =
    // Opera browser detection
    navigator.userAgent ||
    navigator.vendor ||
    (window as Window & { opera?: string }).opera ||
    "";

  // Mobile device patterns
  const mobileRegex =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

  // Additional checks for mobile browsers
  const isMobileUA = mobileRegex.test(userAgent);
  const isTouchDevice =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const isSmallScreen = window.innerWidth <= 768;

  return isMobileUA || (isTouchDevice && isSmallScreen);
};

export const canUseAppSwitch = (): boolean => {
  return isMobileDevice();
};
